import { render, staticRenderFns } from "./ClientsListPage.vue?vue&type=template&id=4f7c2049&"
import script from "./ClientsListPage.vue?vue&type=script&lang=js&"
export * from "./ClientsListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports